<script setup lang="ts">
import TopBanner from './TopBanner.vue';
import type SiteTopBanner from '@store/content/entities/SiteTopBanner';

const contentStore = useContentStore();
const route = useRoute();
const { isMobile } = useSize();
let topBanners = reactive<SiteTopBanner[]>([]);
const filterByPath = (val?: string) => {
    topBanners = contentStore.filteredTopBanners.filter(m =>
        new RegExp(m.urlPattern || '').test(val || route.path)
    );
};
const filterBySize = () => {
    topBanners = topBanners.filter(
        m =>
            !m.displaySize ||
            m.displaySize === 'both' ||
            (m.displaySize === 'mobile' ? isMobile.value : !isMobile.value)
    );
};
filterByPath();
const isMounted = computed(() => contentStore.mounted);
watch(isMounted, () => {
    filterByPath();
    filterBySize();
});
watch(
    () => route.path,
    path => {
        filterByPath(path);
        filterBySize();
    }
);
onMounted(() => {
    filterByPath();
    filterBySize();
});
</script>

<template>
    <Teleport :disabled="!topBanners.length" to="body">
        <div id="__topBanners">
            <TopBanner v-for="banner in topBanners" :key="banner.id" :banner />
        </div>
    </Teleport>
</template>

<style lang="scss" scoped>
#__topBanners {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2147483647;
}
</style>
